import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Fitment Help',
  name: 'fitmentHelp',
  type: 'document',
  fields: [
    defineField({
      title: 'Overview Button Label',
      name: 'overviewButtonLabel',
      type: 'string',
    }),
    defineField({
      title: 'Design Configurator Overview Button Label',
      name: 'designConfiguratorOverviewButtonLabel',
      type: 'string',
    }),
  ],
  preview: {
    select: {
      overviewButtonLabel: 'overviewButtonLabel',
    },
    prepare({ overviewButtonLabel }) {
      return {
        title: overviewButtonLabel || 'Fitment Help',
        subtitle: 'Fitment Help Configuration',
      }
    },
  },
})